import { useEffect, useState } from 'react';
import { client } from 'src/utils/api';
import { getCssVariable, highlightUnderscoreText } from 'src/utils/utils';
import Layout from '../Layout';
import backgroundImage from "../../../images/Gradiant-inner.png";
import { useLocation, useNavigate } from 'react-router-dom';

const TermsandServices = () => {
  const gqlClient = client;
  const primaryColor = getCssVariable('--primary-color');
  const [termsandServices, setTermsandServices] = useState<any>(null);
  const navigate=useNavigate()
  const location = useLocation();
  const pathParts = location.pathname.toLowerCase().split("/").filter(Boolean);
  const isBaseRoute = pathParts.length === 1 && pathParts[0] === "terms-of-service";
  const slug = isBaseRoute ? "terms-of-service" : pathParts[1];
  useEffect(() => {
    const getFooterComponentData = async () => {
      try {
        const securityResponse = await gqlClient.GetPageBySlug({
          slug: slug,
        });        
        const securityId =
        securityResponse?.pageGenericCollection?.items[0]?.sys.id;

      if (!securityId) {
        navigate('/not-found', { replace: true });
        return;
      }
      const response = await gqlClient.GetTextPage({
        id: securityId
      });
        setTermsandServices(response?.pageGeneric?.componentsCollection?.items[0]);
        return;
      } catch (error) {
        console.error('Error fetching Terms and service data:', error);
        return [];
      }
    };

    getFooterComponentData();
  }, []);

  const renderContent = (content: any) => {
    return content.map((item: any, index: number) => {
      if (item.nodeType === 'text') {
        const isBold = item.marks.some((mark: any) => mark.type === 'bold');
        if (
          item.value === 'Organizational Security' ||
          item.value === 'Cloud Security:' ||
          item.value === 'Access Security:' ||
          item.value === 'Vendor and Risk Management:'
        ) {
          return (
            <span key={index} style={{ color: 'red', fontWeight: isBold ? 'bold' : 'normal' }}>
              {item.value}
            </span>
          );
        }
        if (item.marks.some((mark: any) => mark.type === 'bold')) {
          return (
            <strong key={index} className="rich-text-bold mb-1 d-block">
              {item.value}
            </strong>
          );
        }
        return <span key={index} className='mb-3'>{item.value}</span>;
      }

      if (item.nodeType === 'paragraph') {
        return <p key={index} className='mb-3'>{renderContent(item.content)}</p>;
      }

      if (item.nodeType === 'heading-2') {
        return (
          <h2 key={index} className="rich-text-heading mb-1">
            {renderContent(item.content)}
          </h2>
        );
      }

      return null;
    });
  };

  return (
    <Layout
    style={{
      color: "#fff",
    }}
      hamburgerStyle={{
        backgroundColor: primaryColor,
      }}
      saleClassName={'btn-gradient-bdr'}
      headerStyle={{ position: 'relative' }}
      isFooterComponent={true}
    >
    
     <div className="product-banner" style={{minHeight:"200px"}}>
    <div className="product-banner-block" style={{minHeight:"100px"}}>
      <img
        src={backgroundImage}
        alt="background"
        className="background-image"
      />
      <div className="product-gradient-overlay"></div>
      <div className="container-fluid custom-spacer-col position-relative gap-5">
        <div
          className="product-content-wrapper"
          style={{ minHeight: "200px" , marginTop:"200px" }}

        >
         
          <h1
            className="product-title product-title-custom light"
            dangerouslySetInnerHTML={{
              __html: highlightUnderscoreText(termsandServices?.title ?? ""),
            }}
          />
        </div>
      </div>
    </div>
  </div>
      <section className="marquee-component-block" style={{paddingBottom:"300px"}}>
        <div className="container-fluid custom-spacer-col">
          <div className={`row align-items-center`}>
            <div className="rich-text">
              
              {termsandServices && (
                <div className="content">{renderContent(termsandServices.text.json.content)}</div>
              )}
            </div>
          </div>
        </div>
      </section>

    </Layout>
  );
};

export default TermsandServices;
